import { createContext } from "react";

import type {
  TciFunnelStep,
  UpdateTciSessionPayload,
} from "@/lib/api/tci-sessions";

export const VISITOR_SESSION_STORAGE_KEY = "tci-visitor-session-id";

export type TrackVisitorArgs = UpdateTciSessionPayload & {
  currentStep: TciFunnelStep;
  lastEvent: string;
};

export type VisitorTrackingContextValue = {
  /** Server-side TciSession id once created. */
  visitorSessionId: string | null;
  ready: boolean;
  track: (args: TrackVisitorArgs) => void;
};

export const VisitorTrackingContext =
  createContext<VisitorTrackingContextValue | null>(null);
